import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'

export interface ExperimentReducer {
    experiment: any
}

const initialState: ExperimentReducer = {
    experiment: null,
}

const experimentReducer = (state = initialState, action: ActionExtended) => {
    if (action.type === ACTIONS.EXPERIMENT) {
        return {
            ...state,
            experiment: action.payload,
        }
    }
    return state
}

export default experimentReducer
